import React from 'react';
import { api } from '../services/api';
import { useApi } from '../hooks/useApi';
import Topbar from '../components/Topbar';
import Panel from '../components/Panel';
import StatCard from '../components/StatCard';
import { IconScale, IconTrendUp, IconTrendDown } from '../components/icons';

function scoreColor(s) {
  if (s >= 70) return '#10b981';
  if (s >= 50) return '#f59e0b';
  return '#ef4444';
}

export default function Accessibility() {
  const { loading, data, live } = useApi(() => api.accessibility());
  const zones = [...(data?.zones || [])].sort((a, b) => b.score - a.score);
  const best = zones[0];
  const worst = zones[zones.length - 1];
  const avg = zones.length ? Math.round(zones.reduce((a, z) => a + z.score, 0) / zones.length) : 0;

  return (
    <>
      <Topbar title="Indice d'accessibilité territoriale" subtitle="Score composite : offre · temps d'accès · équité" live={live} />
      <div className="content">
        {loading ? <div className="loading-screen">Chargement…</div> : (
          <>
            <div className="kpi-row kpi-row--3">
              <StatCard label="Indice moyen" value={String(avg)} unit="/100" icon={IconScale} delay={0} />
              <StatCard label="Mieux desservie" value={best?.nom || '—'} icon={IconTrendUp} trend={{ dir: 'up', text: `${best?.score}/100` }} delay={70} />
              <StatCard label="Plus défavorisée" value={worst?.nom || '—'} icon={IconTrendDown} trend={{ dir: 'down', text: `${worst?.score}/100` }} delay={140} />
            </div>
            <Panel icon={IconScale} title="Classement des arrondissements" sub="0 (faible) → 100 (excellent)" badge={`${zones.length} zones`} delay={120}>
              {zones.map((z, i) => (
                <div className="desert" key={z.zone_id}>
                  <div className="desert__top">
                    <div><span className="desert__name">{z.nom}</span></div>
                    <span className="mono" style={{ fontWeight: 700, color: scoreColor(z.score) }}>{z.score}/100</span>
                  </div>
                  <div className="desert__bar">
                    <div className="desert__fill" style={{ width: `${z.score}%`, background: scoreColor(z.score), animationDelay: `${i * 60}ms` }} />
                  </div>
                </div>
              ))}
            </Panel>
            <Panel icon={IconScale} title="Décomposition de l'indice" delay={180}>
              <table className="tbl">
                <thead><tr><th>Zone</th><th className="num">Offre</th><th className="num">Temps d'accès</th><th className="num">Équité</th><th className="num">Score</th></tr></thead>
                <tbody>
                  {zones.map((z) => (
                    <tr key={z.zone_id}>
                      <td>{z.nom}</td>
                      <td className="num mono">{z.offre}</td>
                      <td className="num mono">{z.temps_acces}</td>
                      <td className="num mono">{z.equite}</td>
                      <td className="num"><span className="tag" style={{ color: scoreColor(z.score), background: 'var(--slate-100)' }}>{z.score}</span></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </Panel>
          </>
        )}
      </div>
    </>
  );
}
